export default __webpack_public_path__ + "images/VE.c2d51e2.png";